<div class="table-container">
    <table>
        <thead>
            <tr>
                <th class="center">{{ title }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    <form #form="ngForm" class="form">
                        <div class="field">
                            <input type="text" name="firstName" required [(ngModel)]="firstName" #firstNameModel="ngModel" name="firstName" placeholder=" " />
                            <label>First Name</label>
                            <span class="error" *ngIf="firstNameModel.invalid && firstNameModel.touched">
                                First is required
                            </span>
                        </div>
                        <div class="field">
                            <input type="text" name="lastName" required [(ngModel)]="lastName" #lastNameModel="ngModel" placeholder=" "
                            />
                            <label>Last Name</label>
                            <span class="error" *ngIf="lastNameModel.invalid && lastNameModel.touched">
                                Last name is required
                            </span>
                        </div>
                        <div class="field">
                            <input type="text" name="handicapIndex" required [(ngModel)]="handicapIndex" #handicapIndexModel="ngModel" placeholder=" "
                            />
                            <label>Handicap Index</label>
                            <span class="error" *ngIf="handicapIndexModel.invalid && handicapIndexModel.touched">
                                Handicap is required
                            </span>
                        </div>
                        <div class="field">
                            <input type="email" name="email" [(ngModel)]="email" #emailModel="ngModel" placeholder=" "/>
                            <label>Email</label>
                            <span class="error" *ngIf="emailModel.invalid && emailModel.touched">
                                Invalid email address
                            </span>
                        </div>
                        <div class="field">
                            <input type="tel" name="phoneNumber" maxlength="10" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="phone" #phoneModel="ngModel" placeholder=" " (input)="onPhoneInput()" />
                            <label>Phone Number</label>
                            <span class="error" *ngIf="phoneModel.invalid && phoneModel.touched">
                                Invalid phone. 10 digits required, numbers only.
                            </span>
                        </div>
                    </form>
                </td>
            </tr>
            <tr>
                <td>
                    <button (click)="save()">{{ saveButtonText }}</button>
                    <button class="cancel" (click)="cancel()">Cancel</button>
                </td>
            </tr>
        </tbody>
    </table>


</div>
